import FilterNavView from "./FilterNavView";
import TimelineView from "./TimelineView";
import MetadataView from "./MetadataView";
import StatsNavView from "./StatsNavView";
import UINavView from "./UINavView";

class AppView {
  constructor() {
    this.filterNavView = new FilterNavView();
    this.timelineView = new TimelineView();
    this.metadataView = new MetadataView();
    this.statsNavView = new StatsNavView();
    this.uiNavView = new UINavView();
  }
  // Don't need to do this now but maybe add extra lifecycle hooks
  // or global state controls here.
  //
  // mount() {
  //   this.filterNavView.mount();
  //   this.timelineView.mount();
  //   this.metadataView.mount();
  //   this.statsNavView.mount();
  // }
}

export default AppView;
